
export const flattenTiposCuentas = (tiposCuentas) => tiposCuentas.map(tipoCuenta => ({
  id: tipoCuenta.cdCode,
  descripcion: tipoCuenta.dsCode,
  cdCode:tipoCuenta.cdCode,
  dsCode:tipoCuenta.dsCode,
}));
